import { ReactComponent as AccountSmall } from './account.svg'
export default AccountSmall
